import {DOCUMENT} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {MainHubService} from '../../services/main-hub.service';

@Component({
  selector: 'app-view-login',
  templateUrl: './login.component.html',
})
export class LoginComponent {

  loginForm: FormGroup = new FormGroup({
    login: new FormControl('admin', Validators.required),
    password: new FormControl('admin', Validators.required)
  });


  constructor(private mainHubService: MainHubService, private router: Router) {

  }

  async onSubmit() {
    let isLogin = await this.mainHubService.login(this.loginForm.controls["login"].value, this.loginForm.controls["password"].value);
    if(isLogin) {
      await this.mainHubService.checkProvider();
      this.router.navigate(["/"]);
    }
  }

}
